import { createSlice } from "@reduxjs/toolkit";
import { fetchAdvanceCustomerBalance } from "./AdvanceCustomerBalanceThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All Debitor",
    customerId: null,
    locationId: null,
    fromDate: null,
    toDate: null,
  },
};

const advanceCustomerBalanceSlice = createSlice({
  name: "advanceCustomerBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvanceCustomerBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAdvanceCustomerBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchAdvanceCustomerBalance.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = advanceCustomerBalanceSlice.actions;
export default advanceCustomerBalanceSlice.reducer;
